export default {
  sleep: (milliseconds) => {
    return setTimeout(() => { }, milliseconds)
  },
}
